import {useState} from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { CommentWrapper, QuestionWithoutTopic, QuestionWithTopic } from "../common";
import { InDepthKnowledgeType, StagesType } from "../../Constants";
import ReferenceImageModal from "../ReferenceImageModal";
import SolutionModal from "../SolutionModal";

const IndepthSection = ({
    guideData,
    topicList,
    getIndepthQuestions,
    inDepthKnowledgeQuestionTopic,
    downloadFile,
    isIndepthKnowledge,
    commentData,
    ...props
}) => {
    const [imageReferenceModal, setImageReferenceModal] = useState({
        status: false,
        data: null,
    });
    const [solutionModal, setSolutionModal] = useState({
        status: false,
        data: null,
    });
    const IndepthData = guideData[StagesType.INDEPTH_KNOWLEDGE]?.sections;

    const openImageReference = (data) => {
        setImageReferenceModal((prev)=>({...prev, status: true, data}))
    }

    const closeImageReference = () => {
        setImageReferenceModal((prev)=>({...prev, status: false, data: null}))
    }

    const openSolutionModal = (data) => {
        setSolutionModal((prev)=>({...prev, status: true, data}))
    }

    const closeSolutionModal = () => {
        setSolutionModal((prev)=>({...prev, status: false, data: null}))
    }

    const renderSectionDetail = () => {
        let totalCount = 0;
        IndepthData?.map(item => {
            if(item?.type === "INDEPTH_KNOWLEDGE_QUESTIONS_DISTRIBUTION") {
                totalCount = item?.values?.total;
            }
        });
        return (
            <Box className="head-detail-wrapper">
            <Typography className="common-text">Total number of questions to ask: <span className="bold-600">{totalCount}</span></Typography>
            {
                IndepthData?.[0]?.values?.total > 0 &&  IndepthData?.[0]?.values?.question_topic && Object.keys(IndepthData?.[0]?.values?.question_topic)?.length > 0 && (
                    <Box className="topic-main-wrapper">
                        <Typography className="common-text">From the below topic list:</Typography>
                        {topicList()}
                    </Box> 
                    )
            }
            <Box className="difficulty-border-wrapper">
                <span className="easy-border-chip">Easy </span>
                <span className="medium-border-chip">- Medium </span>
                <span className="hard-border-chip">- Hard</span>
            </Box>
        </Box>
        )
    }

    const renderSectionBody = () => {
        let questionList = getIndepthQuestions() || [];
        return (<Box className="question-box-main-container">
                <Box className="question-head-wrapper ">
                    <Typography className="head-text">Questions List</Typography>
                    <Typography className="head-sub-text">These are the questions suggested for you to ask.</Typography>
                </Box>
                <Box className="question-list-main-wrapper">
                    { 
                        inDepthKnowledgeQuestionTopic?.length === 0 ? 
                            <QuestionWithoutTopic
                            type="INDEPTH_KNOWLEDGE"
                            questionList={questionList}
                            openImageReference={openImageReference}
                            openSolutionModal={openSolutionModal}
                            />  : "" }
                    { 
                    inDepthKnowledgeQuestionTopic?.length > 0 ? 
                        <QuestionWithTopic
                        type="INDEPTH_KNOWLEDGE"
                        questionList={questionList}
                        questionTopicData={inDepthKnowledgeQuestionTopic}
                        openImageReference={openImageReference}
                        openSolutionModal={openSolutionModal}
                         /> : ""}
                </Box>
        </Box>)
    }
    return (
        <Box className="common-section-main-wrapper">
             <CommentWrapper
            stageType={StagesType.INDEPTH_KNOWLEDGE}
            sectionType={InDepthKnowledgeType.INDEPTH_KNOWLEDGE_QUESTIONS_DISTRIBUTION}
            sectionCommentData={commentData?.data?.[StagesType.INDEPTH_KNOWLEDGE]?.[InDepthKnowledgeType.INDEPTH_KNOWLEDGE_QUESTIONS_DISTRIBUTION]}
            commentData={commentData}
            {...props}
            >
          {renderSectionDetail()}
          </CommentWrapper>
          <CommentWrapper
            stageType={StagesType.INDEPTH_KNOWLEDGE}
            sectionType={InDepthKnowledgeType.INDEPTH_KNOWLEDGE_QUESTIONS}
            sectionCommentData={commentData?.data?.[StagesType.INDEPTH_KNOWLEDGE]?.[InDepthKnowledgeType.INDEPTH_KNOWLEDGE_QUESTIONS]}
            commentData={commentData}
            {...props}
            >
          {renderSectionBody()}
          </CommentWrapper>
          <ReferenceImageModal
          imageReferenceModal={imageReferenceModal}
          closeImageReference={closeImageReference}
          downloadFile={downloadFile}
          />
           <SolutionModal
            section={"Indepth Question"}
            solutionModal={solutionModal}
            closeSolutionModal={closeSolutionModal}
            isIndepthKnowledge={isIndepthKnowledge}
            />
        </Box>
    )
}
export default IndepthSection;